'use client'

import Artwork from '@/components/Artwork'

/**
 * GRAND VINYLE EN FOND, PLEIN ÉCRAN ET TRANSLUCIDE (vue Vinyle du lecteur +
 * économiseur d'écran TV) : un disque plus grand que l'écran, sillons +
 * reflet, pochette en étiquette au centre, qui tourne pendant la lecture.
 * z-index -1 : il se place SOUS le contenu du parent, qui doit former un
 * contexte d'empilement (fixed, ou classe `isolate`).
 */
export default function VinylBackdrop({ track, playing, fixed = true, opacity = 0.42 }: {
  track: any; playing: boolean; fixed?: boolean; opacity?: number
}) {
  if (!track) return null
  return (
    <div aria-hidden className={`${fixed ? 'fixed' : 'absolute'} inset-0 overflow-hidden pointer-events-none grid place-items-center`}
      style={{ zIndex: -1 }}>
      <div className={`blc-vinyl-bg ${playing ? '' : 'is-paused'}`} style={{ opacity }}>
        <div className="blc-vinyl-bg-label"><Artwork track={track} fill strict size={600} rounded="rounded-full" /></div>
        <span className="blc-vinyl-bg-hole" />
      </div>
      {/* voile : garde le texte lisible par-dessus le disque */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,transparent_0%,rgb(var(--sbg)/.35)_70%,rgb(var(--sbg)/.7)_100%)]" />
    </div>
  )
}
